import React from "react";
import "./PiscinesContainer.css";
import Piscine from "./Piscine/Piscine";

function PiscineContainer() {
  const figuresData = [
    {
      imgSrc: "/img/photo1.jpg",
      title: "Piscine creusée à coque",
      description:
        "Une piscine préfabriquée en matériau composite, rapide à installer et durable, offrant une finition lisse et nécessitant peu d'entretien.",
    },
    {
      imgSrc: "/img/photo2.jpg",
      title: "Piscine béton",
      description:
        "Piscine sur mesure en béton armé, robuste et personnalisable. Sa longévité et sa résistance en font un choix idéal pour des designs variés.",
    },
    {
      imgSrc: "/img/photo3.jpg",
      title: "Piscine à débordement",
      description:
        "Design épuré où l'eau déborde sur un ou plusieurs côtés, créant un effet visuel impressionnant et intégrant harmonieusement la piscine dans le paysage environnant.",
    },
    {
      imgSrc: "/img/photo5.jpg",
      title: "Bassin carrelé",
      description:
        "Piscine dotée de carrelage, offrant une esthétique élégante et moderne. Facile à nettoyer, elle permet une personnalisation avec différents motifs et couleurs.",
    },
  ];

  return (
    <div className="container">
      <div className="header">
        <h2 data-aos="fade-down" data-aos-duration="1000">
          Piscines creusées
        </h2>
        <div className="depth-container">
          <h3
            className="depth-title"
            data-aos="fade-right"
            data-aos-duration="1000"
          >
            En profondeurs
          </h3>
          <div
            className="depth-line"
            data-aos="fade-left"
            data-aos-duration="1000"
          ></div>
        </div>
      </div>

      <div className="figures">
        {figuresData.map((figure, index) => (
          <Piscine
            key={index}
            imgSrc={figure.imgSrc}
            title={figure.title}
            description={figure.description}
            data-aos="fade-up"
            data-aos-duration="1000"
          />
        ))}
      </div>
    </div>
  );
}

export default PiscineContainer;
